// extracted by mini-css-extract-plugin
export default {"root":"EditAvatarModal_root__pkhdR","container":"EditAvatarModal_container__nbv1y"};